import React, { useState, useEffect } from "react";
import { Table, Tag } from "antd";
import {
  EyeFilled,
  DownloadOutlined,
  EyeInvisibleFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { generateFilename } from "../../Helpers/Constane";
import CphActions from "../../redux/customer_payment_history/actions";
import SearchBar from "../../utils/Searchbar";
import HistoryModel from "./Modal/CustomerModel";
import { maskMobileNumber } from "../../utils/MobileNumHide";

const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a.key - b.key,
    width: 100, // Fixed width
  },
  {
    title: "CUSTOMER NAME",
    dataIndex: "cus_name",

    sorter: (a, b) =>
      String(a?.cus_name || "").localeCompare(String(b?.cus_name || "")),
    width: 100, // Fixed width
  },
  {
    title: "CUSTOMER EMAIL",
    dataIndex: "cus_email",
    sorter: (a, b) =>
      String(a?.cus_email || "").localeCompare(String(b?.cus_email || "")),
    width: 100, // Fixed width
  },
  {
    title: "MOBILE NO.",
    dataIndex: "mob_no",
    width: 100, // Fixed width
  },

  {
    title: "AADHAR NO",
    dataIndex: "addhar_no",
    width: 100, // Fixed width
  },
  {
    title: "HISTORY",
    dataIndex: "history",
    width: 100, // Fixed width
  },

];

const { getCphData,getCphDetailData } = CphActions;

function CustomerPaymentHistory() {
  const dispatch = useDispatch();
  const [formatDate, setFromDate] = useState("");
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const { cphResponseData, totalData, loading } = useSelector(
    (state) => state.chpReducer
  );
  const profileData = useSelector(state => state.authReducer.profileData);
 
  const [historyModel, setHistoryModel] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);
 

  const handleCancel = () => {
    setHistoryModel(false);
    setTransactionHistory([]);
  };



  const data =
    cphResponseData &&
    cphResponseData?.length > 0 &&
    cphResponseData?.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        mob_no: maskMobileNumber(items.mobileNumber),
        cus_email: items.email ? items.email : <Tag>{""} </Tag>,
        cus_name: items.name ? items.name : <Tag>{""} </Tag>,
        addhar_no: items.aadhaar ? items.aadhaar : <Tag>{""} </Tag>,
        history: (
          <>
            {historyModel ? (
              <EyeInvisibleFilled
                style={{
                  fontSize: "18px",
                  color: "#073763",
                  marginLeft: "10px",
                }}
                onClick={handleCancel}
              />
            ) : (
              <EyeFilled
                style={{
                  fontSize: "18px",
                  color: "#073763",
                  marginLeft: "10px",
                }}
                onClick={() => handleViewHistroy(items)}
              />
            )}
          </>
        ),
      };
    });

  const handleViewHistroy = (data) => {
    const agentId = profileData?.orgId
    dispatch(getCphDetailData(data?.mobileNumber , 0, 10, "" , "" , "" ,agentId))
    setHistoryModel(true);
    setTransactionHistory(data);
  };

  let timeoutId;
  const handleFilterChange = (e) => {
    const agentId = profileData?.orgId
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }
    timeoutId = setTimeout(() => {
      if(cphResponseData?.length >= 0 && profileData) {
        dispatch(getCphData(0, 10, "" , "" , value , agentId));
      }
    }, 1000);
  };

  const handlePageChange = async (pagination, filters, sorter) => {
    const agentId = profileData?.orgId
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
      dispatch(getCphData(current -1, pageSize,"","","",agentId));
  };


  // const exportData =
  //   cphResponseData &&
  //   cphResponseData.length > 0 &&
  //   cphResponseData.map((items, index) => {
  //     return {
  //       mob_no: maskMobileNumber(items.mobileNumber),
  //       cus_email: items.email,
  //       cus_name: items.name,
  //       addhar_no: <Tag>{items.aadhaar}</Tag>,
  //     };
  //   });

    useEffect(() => {
      if (profileData) {
        dispatch(getCphData(0, 10,"","","", profileData?.orgId));
      }
    }, [dispatch , profileData]);


  return (
    <>
    <div className="mainContain">
      <h1 className="transaction">Customer Payment History</h1>
      <div className="datesearchFi">
        <div className="">
          <SearchBar onChange={handleFilterChange} />
        </div>
        {/* {data?.length > 0 ?
        <div className="exportBtnDiv">
          <CSVLink
            filename={generateFilename("customer_payment_History")}
            data={exportData ? exportData : []}
            className="btn exportBtn"
          >
            <DownloadOutlined />
            Export
          </CSVLink>
        </div>
        : ""} */}
      </div>

      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          scroll={{ x: 600 }}
          pagination={{
            total: totalData, // totalData,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["3","10", "20", "50"],
          }}
          onChange={handlePageChange}
        />
      </div>

     
    </div>
    <HistoryModel
        fromTitle="Transaction Detail"
        open={historyModel}
        handleCancel={handleCancel}
        transactionHistory={transactionHistory}
      />
      </>
  );
}

export default CustomerPaymentHistory;
